/* eslint-disable indent */
/* eslint-disable no-unused-vars */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-undef */
/* eslint-disable getter-return */
/* eslint-disable default-case */
/* eslint-disable no-use-before-define */
/* eslint-disable func-style */
/**
 * Number.isInteger Polyfill for IE fix
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isInteger#Polyfill
 */

Number.isInteger =
  Number.isInteger ||
  ((value) =>
    typeof value === 'number' &&
    // eslint-disable-next-line no-restricted-globals
    isFinite(value) &&
    Math.floor(value) === value);

((window, document) => {
  const AJAX_MBS_URL = '/content/api/ajax_mbs_search.p';
  // const AJAX_ECOMM_SERVICE = '/content/api/ajax_ecomm_services.p';
  /**
   * Check if we are on the reserve it now checkout page
   * @type {boolean}
   */
  let isReserveItNowCheckout;
  let temp = 1;
  const isApplyForFinancePage = window.location.pathname.includes('apply-for-finance');

  // Get the reference to the existing quote
  let savedQuote =
    window.existingQuote && window.existingQuote.savedQuoteResult
      ? window.existingQuote.savedQuoteResult
      : null;
  // Get the reference to the order details
  const orderDetail =
    window.orderDetails && window.orderDetails.orderDetail ? window.orderDetails.orderDetail : null;

  // Get the dataLayer object
  window.dataLayer = window.dataLayer || [];

  /**
   * Get the ecomm form nav items in order to populate the stepper nav
   * @param {boolean} isCashDeal If the quote deal is cash deal
   */
  const getEcommFormNavItems = (isCashDeal = false) => {
    const navItems = [
      {
        id: 'js-summary-step',
        title: 'Order Summary',
        paths: ['/order-summary/'],
        step: 1,
      },
      {
        id: 'js-checkout-step',
        title: 'Checkout',
        paths: ['/checkout/'],
        step: 2,
      },
      {
        id: 'js-checkout-payment-step',
        title: 'Payment',
        paths: ['/checkout-payment/'],
        step: 4,
      },
      {
        id: 'js-finance-step',
        title: 'Finance Application',
        paths: ['/apply-for-finance/'],
        step: 3,
      },
      {
        id: 'js-confirmation-step',
        title: 'Order Confirmation',
        paths: ['/order-confirmation/'],
        step: 4,
      },
    ];

    return isCashDeal ? navItems.filter((item) => item.title !== 'Finance Application') : navItems;
  };

  /**
   * Get the nav items for reserve it now checkout
   */
  const getReserveItNowItems = () => [
    {
      id: 'js-details-step',
      title: 'Your details',
      paths: ['/reserve/'],
    },
    {
      id: 'js-checkout-payment-step',
      title: 'Payment',
      paths: ['/checkout/'],
    },
    {
      id: 'js-checkout-confirmation-step',
      title: 'Confirmation',
      paths: ['/checkout-confirmation/'],
    },
  ];

  const getProductDetails = (quote) => ({
    name: quote.Quote.VehicleDsc,
    id: quote.Quote.VehicleDetail.vcj_stock_ref,
    price: quote.Quote.VehiclePrice,
    category: 'Used Car',
    variant: quote.Quote.VehicleDetail.vcj_ext_colour,
    quantity: 1,
  });

  const ecommerceTracking = (step, option) => {
    try {
      // Push google ecommerce data layer (Simon)
      window.dataLayer.push({
        event: 'checkout',
        ecommerce: {
          checkout: {
            actionField: {
              step,
              option,
            },
            products: [getProductDetails(savedQuote)],
          },
        },
      });
    } catch (err) {
      /* empty */
    }
  };

  /**
   * Check if the passed item is active based on the locations pathname
   * @param {object} navItem The nav item to check
   */
  const isActiveStep = (navItem, receiptType) => {
    for (let i = 0, len = navItem.paths.length; i < len; i += 1) {
      if (window.location.pathname.includes(navItem.paths[i]) && receiptType !== 'RESERVE_IT_NOW') {
        ecommerceTracking(navItem.step, savedQuote.custFinanceSts);
        return true;
      }
    }

    return false;
  };

  /**
   * A wrapper for generating templates with template literals
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals
   * @param {string[]} strings The strings array of the template literals
   * @param {any[]} keys The values passed in
   * @returns {() => string} The returned function to be used for creating templates
   * @example
   * var t1Closure = template`${0}${1}${0}!`;
   * t1Closure('Y', 'A');  // "YAY!"
   * var t2Closure = template`${0} ${'foo'}!`;
   * t2Closure('Hello', {foo: 'World'});  // "Hello World!"
   */
  const template =
    (strings, ...keys) =>
    (...values) => {
      const dict = values[values.length - 1] || {};
      const results = [strings[0]];
      for (let i = 0, len = keys.length; i < len; i += 1) {
        const value = Number.isInteger(keys[i]) ? values[keys[i]] : dict[keys[i]];
        results.push(value, strings[i + 1]);
      }
      return results.join('');
    };

  /**
   * Push a checkout step object google dataLayer analytics
   * @param {string} step The step title of the page
   * @param {string} event The event name to push
   */
  const checkoutTracking = (step, event) => {
    // Push custom event to the data layer (Nathan)
    window.dataLayer.push({
      event,
      checkoutSteps: {
        step,
      },
    });
  };

  /**
   * Convert a number with commas
   * @param {number|string} num The number to convert
   * @returns {string}
   */
  const numberWithCommas = (num) => {
    const parts = num.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    if (parts[1]) {
      parts[1] = parts[1].slice(0, 2);
      parts[1] = parts[1].replace(/00$/, '');
    }

    return parts[1] && parts[1] !== '' ? parts.join('.') : parts[0];
  };

  /**
   * Convert a number to GBP currency
   * @param {string|number} num The number to convert
   */
  const gbpCurrency = (num) => `&pound;${numberWithCommas(num)}`;

  class SectionItem {
    /**
     * Create a section item for using it to the template
     * @param title The title of the item
     * @param value The value of the item
     * @param isCurrency If the value is a currency
     * @param tooltip The tooltip to add to the items (optional)
     */
    constructor(title, value, isCurrency = true, tooltip = '') {
      tooltip =
        tooltip !== ''
          ? `<span class="tooltip tooltip--top-center">
        <i class="fal fa-info-circle" aria-hidden="true"></i>
        <div class="tooltip__content tooltip__content--thin">
          <p class="tooltip__text text-size--smaller font--regular">
            ${tooltip}
          </p>
        </div>
      </span>`
          : '';

      this.title = title + (tooltip !== '' ? tooltip : '');
      this.value = isCurrency ? gbpCurrency(value) : numberWithCommas(value);
    }
  }

  /**
   * Init the session checks
   */
  const initSessionChecks = () => {
    let idleTime = 0;
    let keyPressEventCount = 0;
    let mouseOverEventCount = 0;
    let lastCheckTime;
    /**
     *  Get the first time on the init
     */
    const firstCheckTime = Date.now();

    sessionCheck();

    // Check session when window is getting focused
    window.addEventListener('focus', sessionCheck.bind(this));

    window.setInterval(() => {
      idleTime += 1;
      if (idleTime > 14) {
        sessionCheck();
      }
    }, 60000);

    /**
     * On mouseenter, get the first time and extend the session
     * After the first session extend, only allow it again after a minute
     * of the last check to keep the api calls down
     */
    document.addEventListener('mouseenter', () => {
      const currentCheckTime = Date.now();
      mouseOverEventCount += 1;

      if (mouseOverEventCount === 1) {
        extendSessionExpiry();
        lastCheckTime = Date.now();
        // console.log('Mouseenter: first check time, extend session', firstCheckTime);
      }

      if (currentCheckTime - lastCheckTime > 60000) {
        extendSessionExpiry();
        lastCheckTime = Date.now();
        // console.log('Mouseenter: After a minute, extend session', lastCheckTime);
      }

      /**
       * Reset the idle time
       */
      idleTime = 0;
    });

    /**
     * On keypress, get the first time and extend the session
     * After the first session extend, only allow it again after a minute
     * of the last check to keep the api calls down
     */
    window.addEventListener('keypress', () => {
      const currentCheckTime = Date.now();
      keyPressEventCount += 1;

      if (keyPressEventCount === 1) {
        extendSessionExpiry();
        lastCheckTime = Date.now();
        // console.log('Keypress: first key press check time, extend session', lastCheckTime);
      }

      if (currentCheckTime - lastCheckTime > 60000) {
        extendSessionExpiry();
        lastCheckTime = Date.now();
        // console.log('Keypress: After a minute key press, extend session', lastCheckTime);
      }
      /**
       * Reset the idle time
       */
      idleTime = 0;
    });
  };

  const sessionCheck = () => {
    if (typeof window.SessionCheck !== 'undefined') {
      window.SessionCheck.checkSession(AJAX_MBS_URL, 'check')
        .then((res) => {
          const data = res.myData;
          if (data.myResultData[0].sessionSts === 'SECURE') {
            window.Cookie.get('mcSess').split('-');
          } else {
            // eslint-disable-next-line no-unused-expressions
            [null, null];
          }
        })
        .catch((err) => {
          window.vm.debug.error(err);
        });
    }
  };

  const extendSessionExpiry = () => {
    if (typeof window.SessionCheck !== 'undefined') {
      window.SessionCheck.checkSession(AJAX_MBS_URL, 'extend')
        .then(() => {})
        .catch((err) => {
          window.vm.debug.error(err);
        });
    }
  };

  const getOptionAccessoryPrice = (options) =>
    options
      .reduce((total, option) => {
        // Check if the option is chosen
        if (option.Chosen === 'Yes') {
          // Check if it has a cashPrice field (accessories)
          if (Object.prototype.hasOwnProperty.call(option, 'CashPrice')) {
            total += parseFloat(option.CashPrice.replace('\u00A3', ''));

            // Else check if it has a cost field (deliveryOptions)
          } else if (Object.prototype.hasOwnProperty.call(option, 'Cost')) {
            total += parseFloat(option.Cost.replace('\u00A3', ''));

            if (option.Cost === 'Free') {
              total = 0;
            }
          }
        }
        return total;
      }, 0)
      .toFixed(2);

  /**
   * Get the vehicle element required for sticky position when there are no ECOMM options
   */
  const getVehicleElementsStd = () => ({
    tileContainer: document.querySelector('.js-std-vehicle-container') || false,
  });

  /**
   * Get the vehicle elements required for binding the data
   */
  const getVehicleElements = () => ({
    tileContainer: document.querySelector('.js-vehicle-container') || false,
    image: document.querySelector('.js-vehicle-img') || false,
    body: document.querySelector('.js-vehicle-body') || false,
    desc: document.querySelector('.js-vehicle-desc') || false,
    link: document.querySelector('.js-vehicle-link') || false,
    quoteExpired: document.querySelector('.js-quote-expired') || false,
    quoteUnavailable: document.querySelector('.js-quote-unavailable') || false,
    quoteDetailsContainer: document.querySelector('.js-details-container') || false,
    spinner: document.querySelector('.js-spinner') || false,
    header: document.querySelector('.site-nav-container') || false,
    detailsToggler: document.querySelector('.js-toggle-details') || false,
    mobileDesc: document.querySelector('.js-mobile-desc') || false,
  });

  const getVehicleBodySectionItems = (items) => {
    const vehicleSectionItemsTemplate = template`
      <div class="xs-col-8">
        ${'title'}
      </div>
      <div id="${'id'}" class="xs-col-4 text-align--right font--bold">
        ${'value'}
      </div>
    `;

    let result = '';

    for (let i = 0, len = items.length; i < len; i += 1) {
      const itemID = items[i].title.includes('APR') ? 'APR' : '';
      result += vehicleSectionItemsTemplate({
        title: items[i].title,
        value: items[i].value,
        id: itemID,
      });
    }

    return result;
  };

  const getVehicleQuoteRefSection = () => {
    const quoteRef = document.querySelector('#quoteRef');

    if (!quoteRef) {
      return '';
    }

    const vehicleSectionQuoteRefTemplate = template`
    <p class="result-tile__summary">
      Quote Reference Number: <strong>${'ref'}</strong>
    </p>
  `;

    const result = vehicleSectionQuoteRefTemplate({
      ref: quoteRef.textContent,
    });

    return result;
  };

  const generateVehicleBodySection = (items, sectionClasses = '', isPrice = true) => {
    const vehicleSectionTemplate = template`
      <div class="section--x-small ${0}">
        <div class="row row--no-margin">
          ${1}
        </div>
      </div>
    `;

    const getSectionFunc = isPrice
      ? getVehicleBodySectionItems(items)
      : getVehicleQuoteRefSection();

    return vehicleSectionTemplate(sectionClasses, getSectionFunc);
  };

  const getTotalCostSection = (quote) => {
    const costSectionItems = [];

    // If has part ex
    if (quote.Quote.PartEx.PartExSts === 'HasPartEx') {
      const detailsContainer = document.querySelector('.js-details-container');
      // const partExBtn = document.querySelector('.js-go-to-part-ex-btn');
      // console.log(detailsContainer);

      if (detailsContainer) {
        detailsContainer.classList.add('deal-has-part-ex');
      }
    }

    // Check if it is a cash deal or finance deal
    if (quote.isCashDeal === 'Yes') {
      if (quote.Quote.PartEx.PartExSts === 'HasPartEx') {
        costSectionItems.push(
          new SectionItem('Part exchange value', `${quote.Quote.PartEx.PartExEquityVal}`),
        );
      }

      costSectionItems.push(new SectionItem('Total checkout price', quote.Quote.CheckOutAmount));
    } else if (quote.Quote.PCPAPR || quote.Quote.HPAPR) {
      // Push cash price
      costSectionItems.push(new SectionItem('Cash price', quote.Quote.CashPrice));

      if (quote.Quote.PartEx.PartExSts === 'HasPartEx') {
        costSectionItems.push(
          new SectionItem('Part exchange value', `${quote.Quote.PartEx.PartExEquityVal}`),
        );
      }

      costSectionItems.push(
        new SectionItem(
          'Total amount payable',
          quote.Quote.PCPAPR ? quote.Quote.PCPAPR.TotAmntPayable : quote.Quote.HPAPR.TotAmntPayable,
        ),
      );
    }

    return generateVehicleBodySection(costSectionItems, 'section--padding-top-only');
  };

  const getHPPCPSection = (quote) => {
    const quoteSectionClasses = 'section--border-bottom text--dark-grey';
    const quoteSectionItems = [];

    // Push monthly payments
    quoteSectionItems.push(
      new SectionItem(
        'Monthly payment',
        quote.Quote.PCPAPR ? quote.Quote.PCPAPR.MonthlyPayment : quote.Quote.HPAPR.MonthlyPayment,
      ),
    );

    // Push deposit
    quoteSectionItems.push(new SectionItem('Deposit', quote.Quote.Deposit));

    // Push term
    quoteSectionItems.push(
      new SectionItem(
        'Term',
        `${quote.Quote.PCPAPR ? quote.Quote.PCPAPR.Term : quote.Quote.HPAPR.Term} months`,
        false,
      ),
    );

    // Push annual mileage
    if (quote.Quote.PCPAPR) {
      quoteSectionItems.push(new SectionItem('Annual mileage', quote.Quote.AnnualMileage, false));
    }

    const APR = new SectionItem(
      'Representative APR',
      `${quote.Quote.PCPAPR ? quote.Quote.PCPAPR.APR : quote.Quote.HPAPR.APR}`,
      false,
    );

    APR.value += '%';

    quoteSectionItems.push(APR);

    return generateVehicleBodySection(quoteSectionItems, quoteSectionClasses);
  };

  const getVehicleDescription = (quote) => {
    const vehicleDescTemplate = template`
        <div class="section--x-small section--border-bottom hide--tablet-down">
        <h4 class="line-height--small">
          ${'desc'}
        </h4>
        <div class="row row--no-margin text--dark-grey">
          ${0}
        </div>
        </div>
      `;

    return vehicleDescTemplate(
      getVehicleBodySectionItems([new SectionItem('Vehicle Price', quote.Quote.VehiclePrice)]),
      {
        desc: quote.Quote.VehicleDsc,
      },
    );
  };

  const generateVehicleDetailsBody = (quote) => {
    // Store the details body results
    let bodyResult = '';

    // Add the Vehicle description
    bodyResult += getVehicleDescription(quote);

    if (!isReserveItNowCheckout) {
      // Check if the vehicle has HP/PCP
      if (quote.Quote.PCPAPR || quote.Quote.HPAPR) {
        bodyResult += getHPPCPSection(quote);
      }

      // Get delivery and accessories costs
      bodyResult += generateVehicleBodySection(
        [
          new SectionItem('Accessories', getOptionAccessoryPrice(quote.Quote.Options)),
          new SectionItem('Delivery', getOptionAccessoryPrice(quote.Quote.DeliveryOptions)),
          new SectionItem(
            'Road tax',
            numberWithCommas(quote.Quote.Rfl.Price),
            true,
            quote.Quote.Rfl.Description,
          ),
        ],
        'section--border-bottom text--dark-grey',
      );

      // Get total cost
      bodyResult += getTotalCostSection(quote);

      bodyResult += generateVehicleBodySection(null, 'section--padding-top-only', false);
    } else {
      bodyResult += generateVehicleBodySection([
        new SectionItem('Reservation fee', quote.Quote.VehicleDetail.vcj_reservation_fee, false),
      ]);
      bodyResult += `<p><i class="fas fa-map-marker-alt" aria-hidden="true"></i> ${quote.Quote.VehicleDetail.vcj_location}</p>`;
    }

    return bodyResult;
  };

  const handleExpiredQuote = (elements) => {
    if (elements.quoteDetailsContainer && elements.quoteExpired) {
      elements.desc.textContent = savedQuote.Quote.VehicleDsc;
      elements.link.setAttribute('href', savedQuote.Quote.VehicleDetail.vcj_vehicle_url);
      elements.quoteDetailsContainer.classList.add('hide__default');
      elements.quoteExpired.classList.remove('hide__default');
    }
  };

  const handleStickyPosition = (isStdVehContainer) => {
    // Choose correct element to be sticky
    const { tileContainer: vehicleContainer } = isStdVehContainer
      ? getVehicleElementsStd()
      : getVehicleElements();

    if (!vehicleContainer) {
      return;
    }

    // Get the container height
    const containerHeight = vehicleContainer.getBoundingClientRect().height;
    const containerTop = vehicleContainer.offsetTop;

    // Get the parent element and the height/top of it
    const { parentElement } = vehicleContainer;
    const { y: parentTop, height: parentHeight } = parentElement.getBoundingClientRect();

    const windowTop = Math.round(window.pageYOffset);
    const maxWindowTop = parentTop + windowTop;

    const maxContainerTop = Math.round(Math.abs(parentHeight - containerHeight - 20));

    // If the window has scrolled above the container
    if (windowTop < maxWindowTop || window.innerWidth < 880 || parentHeight <= containerHeight) {
      vehicleContainer.removeAttribute('style');
      return;
    }

    // If the window has scrolled bellow the container
    if (windowTop > maxWindowTop) {
      // If the window has scrolled above the max container top
      if (windowTop - maxWindowTop < maxContainerTop) {
        vehicleContainer.setAttribute(
          'style',
          `position: absolute; top: ${Math.abs(parentTop)}px;`,
        );
      } else if (containerTop !== maxContainerTop) {
        // If the container is not set to the max container top when
        // the window is scrolling bellow the parent height
        vehicleContainer.setAttribute('style', `position: absolute; top: ${maxContainerTop}px;`);
      }
    }
  };

  /**
   * Handle the page views for the data layers analytics
   * @param {string} pathname The window's location path
   */
  const handlePageView = (pathname) => {
    let event = '';

    if (savedQuote) {
      event = savedQuote.isCashDeal === 'Yes' ? 'cashPurchaseStep' : 'financeStep';
    }

    switch (true) {
      case pathname.includes('/order-summary/'):
        checkoutTracking('orderSummary', event);
        break;
      case pathname.includes('/apply-for-finance/'):
        checkoutTracking('financeApplication', event);
        break;
      case pathname.includes('/checkout/'):
        checkoutTracking('checkout', event);
        break;
      case pathname.includes('/checkout-confirmation/'):
        checkoutTracking('checkoutConfirmation', event);
        break;
    }
  };

  /**
   * Get the quotes of the customer
   * @param {string} quoteId The quote's id
   */
  const getQuote = (quoteId) => {
    if (typeof quoteId === 'string' && quoteId !== '') {
      const URI = `/content/api/ajax_ecomm_services.p?Action=GetQuotes&QuoteId=${quoteId}`;
      // const URI = '/js/MyQuotesJSON.json';

      return axios.get(URI).then(({ data }) => {
        if (typeof data !== 'string' && data.getQuotes && data.getQuotes.length) {
          return data.getQuotes[0];
        }
        throw new Error(`Quote for quoteId: ${quoteId} was not found.`);
      });
    }

    return Promise.resolve(null);
  };

  /**
   * Call the ecomm services on the enquire page
   * @param {object} financeParams the finance params object from the session storage
   */
  const getFinance = (financeParams) => {
    // Get the franchis quote id input from the form
    const quoteIdInput = document.getElementById('Q634');

    // Add the quote id value to the input
    if (quoteIdInput && quoteIdInput !== null) {
      quoteIdInput.value = financeParams.QuoteId;
    }

    // Build the URL with the params
    const URI =
      `/content/api/ajax_ecomm_services.p?Action=FinanceCalc&QuoteId=${financeParams.QuoteId}` +
      `&StockRef=${financeParams.StockRef}&SpecRef=${financeParams.SpecRef}&AnnualMileage=${financeParams.AnnualMileage}` +
      `&Term=${financeParams.Term}&TermPCP=${financeParams.TermPCP}&TermHP=${financeParams.TermHP}&dealDeposit=${financeParams.dealDeposit}` +
      `&extras=${financeParams.extras}&delivery=${financeParams.delivery}&cashSelected=${financeParams.cashSelected}&financeTypeSelected=` +
      `${financeParams.financeTypeSelected}&quoteCalcTime=${financeParams.quoteCalcTime}`;

    return axios.get(URI).then(({ data }) => {
      if (typeof data !== 'string' && data) {
        return data;
      }
      throw new Error(`Quote for quoteId: ${financeParams.QuoteId} was not found.`);
    });
  };

  const initlaizeFormNav = (quote) => {
    const formNavContainer = document.querySelector('.js-form-nav');

    // Store the form nav items template and if the template should have the item ticked
    let formNavItemsTemplate = '';
    let isTicked = false;

    // Create a ul element to contain the nav
    const navList = document.createElement('ul');
    navList.className = 'form-nav form-nav--small';

    const formNavItems = isReserveItNowCheckout
      ? getReserveItNowItems()
      : getEcommFormNavItems(quote.isCashDeal === 'Yes');

    // Loop through the nav items and generate the item template
    for (let i = formNavItems.length - 1; i >= 0; i -= 1) {
      const isActive = isActiveStep(formNavItems[i], quote.receiptType);

      formNavItemsTemplate = `
        <li class="form-nav__item${isActive || isTicked ? ' is-active' : ''} ${formNavItems[i].id}">
          <div class="nav-item__step">
            <i class="far fa-check nav-item__step-icon${
              isTicked ? '' : ' hide__default'
            }" style="font-size: 1.2em;"></i>
            <span class="nav-item__step-number${isTicked ? ' hide__default' : ''}">${i + 1}</span>
          </div>
          <div class="nav-item__title">
            ${formNavItems[i].title}
          </div>
        </li>
      ${formNavItemsTemplate}`;

      if (!isTicked && isActive && i > 0) {
        isTicked = true;
      }
    }

    // Add the form nav items
    navList.innerHTML = formNavItemsTemplate;

    if (formNavContainer) {
      formNavContainer.appendChild(navList);
    }
  };

  /**
   * Handle the apply for finance page to display the login
   * screen in case of the user not being logged in
   * @param {{ [key:string]: HTMLElement }} vehicleElements The vehicle elements on the page
   */

  const handleApplyForFinancePage = (vehicleElements) => {
    if (typeof window.SessionCheck !== 'undefined') {
      window.SessionCheck.checkSession(AJAX_MBS_URL, 'check')
        .then((res) => {
          const data = res.myData;
          if (isApplyForFinancePage && data.myResultData[0].sessionSts === 'PUBLIC') {
            window.vm.jsImport('/js/modules/dist/login-register.js').then(() => {
              const loginRegisterContainer = document.querySelector('.js-login-register');
              vehicleElements.quoteDetailsContainer.classList.add('hide__default');
              vehicleElements.quoteUnavailable.classList.add('hide__default');
              vehicleElements.quoteExpired.classList.add('hide__default');
              loginRegisterContainer.classList.remove('hide__default');
              window.addEventListener('onLogIn', () => window.location.reload());
            });
          }
        })
        .catch((err) => {
          window.vm.debug.error(err);
        });
    }
  };

  /**
   * Handle the data response
   * @param {*} data The data to append to the response
   */
  // const handleDataResponse = (data) => {
  //   try {
  //     const orderConfirmation = document.querySelector('.js-order-confirmation');
  //     const confirmationFragment = new DocumentFragment();
  //     const confirmationDiv = document.createElement('div');
  //     confirmationDiv.innerHTML = data;
  //     confirmationFragment.appendChild(confirmationDiv);
  //     orderConfirmation.appendChild(confirmationFragment);
  //     handleFinanceTypes();
  //   } catch (err) {}
  // };

  /**
   * Handle the elements onm the checkout respone
   */
  // const handleCheckoutResponse = () => {
  //   try {
  //     const hideIfConfirmation = document.querySelectorAll('.js-hide-if-no-dep-confirmation');
  //     const showIfConfirmation = document.querySelectorAll('.js-show-if-no-dep-confirmation');

  //     if (hideIfConfirmation) {
  //       hideIfConfirmation.forEach(el => {
  //         el.classList.add('hide__default');
  //       });
  //     }

  //     if (showIfConfirmation) {
  //       showIfConfirmation.forEach(el => {
  //         el.classList.remove('hide__default');
  //       });
  //     }

  //     handleFinanceTypes();
  //   } catch (err) {}
  // };

  // const handleFinanceTypes = () => {
  //   try {
  //     if (window.parent.document.querySelector('.deal-has-part-ex')) {
  //       const pxEl = document.querySelector('.js-go-to-part-ex-btn');
  //       pxEl.classList.remove('hide__default');
  //     }

  //     if (document.querySelector('.finance-url a').getAttribute('href') !== '') {
  //       document.querySelector('.finance-url').classList.remove('hide__default');
  //       const fnEl = document.querySelectorAll('.hide--if-finance');
  //       fnEl.forEach(el => {
  //         el.classList.add('hide__default');
  //       });
  //     } else {
  //       const cashEl = document.querySelectorAll('.hide--if-cash');
  //       cashEl.forEach(el => {
  //         el.classList.add('hide__default');
  //       });
  //     }
  //   } catch (err) {}
  // };

  /**
   * Handle the finance/cash messaging
   */
  const handleMessages = () => {
    // Hide the reserve-it-now, finance-deal messages
    document.querySelector('.js-part-ex-deal').classList.add('hide__default');
    document.querySelector('.js-reserve-it-now').classList.add('hide__default');
    document.querySelector('.js-cash-deal').classList.add('hide__default');
    document.querySelector('.js-finance-deal').classList.add('hide__default');
  };

  const updateNavs = () => {
    const confirmStep = document.querySelector('.js-confirmation-step');
    const checkoutConfirmStep = document.querySelector('.js-checkout-confirmation-step');
    const checkoutTitle = document.querySelector('.js-checkout-heading');
    const checkoutStep = document.querySelector('.js-checkout-step');
    const checkoutPaymentStep = document.querySelector('.js-checkout-payment-step');
    if (checkoutStep) {
      checkoutStep.classList.add('is-active');
      checkoutStep.querySelector('.nav-item__step-number').classList.add('hide__default');
      checkoutStep.querySelector('.nav-item__step-icon').classList.remove('hide__default');
    }
    if (checkoutPaymentStep) {
      checkoutPaymentStep.classList.add('is-active');
      checkoutPaymentStep.querySelector('.nav-item__step-number').classList.add('hide__default');
      checkoutPaymentStep.querySelector('.nav-item__step-icon').classList.remove('hide__default');
    }
    // if the confirm step nav is present, tick it and highlight it
    if (confirmStep) {
      confirmStep.querySelector('.nav-item__step-number').classList.add('hide__default');
      confirmStep.querySelector('.nav-item__step-icon').classList.remove('hide__default');
      confirmStep.classList.add('is-active');
    }
    // if the checkout confirm step nav is present, tick it and highlight it
    if (checkoutConfirmStep) {
      checkoutConfirmStep.querySelector('.nav-item__step-number').classList.add('hide__default');
      checkoutConfirmStep.querySelector('.nav-item__step-icon').classList.remove('hide__default');
      checkoutConfirmStep.classList.add('is-active');
    }
    // Hide checkout title when payment is done
    if (checkoutTitle) {
      checkoutTitle.closest('.section--small').classList.add('hide__default');
    }

    // Hide the reserve-it-now, finance-deal messages
    handleMessages();
  };

  // Check the dom for either confirmation step type. If one is present then nav has loaded.
  const checkNavLoad = () => {
    const checkoutPaymentStep =
      document.querySelector('.js-confirmation-step') ||
      document.querySelector('.js-checkout-confirmation-step');
    // If nave has loaded, highlight the correct elems
    if (checkoutPaymentStep) {
      updateNavs();
    } else {
      // If they haven't yet loaded, retry after 100ms. Do this until they have loaded.
      setTimeout(checkNavLoad, 100);
    }
  };

  /**
   * Handle no deposit elements
   */
  // const handleNoDepositElements = () => {
  //   const elementsToRemove = document.querySelectorAll('.js-remove-if-no-deposit');
  //   const elementsToShow = document.querySelectorAll('.js-show-if-no-deposit');
  //   const sessionQuote = sessionStorage.getItem(`financeParams${savedQuote.StockRef}`);
  //   const financeParams = JSON.parse(sessionQuote);
  //   const hasZeroDeposit = financeParams ? financeParams.dealDeposit === 0 : false;
  //   const cashSelected = financeParams ? financeParams.cashSelected === true : false;

  //   if (hasZeroDeposit && !cashSelected && !isReserveItNowCheckout) {
  //     elementsToRemove.forEach(el => {
  //       el.classList.add('hide__default');
  //     });
  //     elementsToShow.forEach(el => {
  //       el.classList.remove('hide__default');
  //     });
  //   } else {
  //     elementsToRemove.forEach(el => {
  //       el.classList.remove('hide__default');
  //     });
  //     elementsToShow.forEach(el => {
  //       el.classList.add('hide__default');
  //     });
  //   }
  //   // console.log(financeParams.dealDeposit, hasZeroDeposit, !cashSelected);
  // };

  /**
   * Handle the deposit checkout
   */
  // const handleNoDepositCheckout = (quoteId, dealHash) => {
  //   const noDepositBtn = document.querySelector('.js-reserve-with-no-deposit');
  //   const URI =
  // `${AJAX_ECOMM_SERVICE}?Action=ConfirmWithNilDeposit&QuoteId=${quoteId}&dealHash=${dealHash}`;

  //   if (noDepositBtn) {
  //     noDepositBtn.addEventListener('click', () => {

  //       const vehicleElements = getVehicleElements();

  //       if (vehicleElements.spinner) {
  //         vehicleElements.spinner.style.position = 'absolute';
  //         vehicleElements.spinner.classList.remove('hide__default');
  //       }

  //       axios.get(URI)
  //         .then(({ data }) => {

  //           if (!data) {
  //             return data;
  //           }

  //           // If successful response
  //           if (data.confirm0DepositResponse) {
  //             handleDataResponse(data.confirm0DepositResponse.ecommPaidElvn);
  //             handleCheckoutResponse();

  //             if (vehicleElements.spinner) {
  //               vehicleElements.spinner.style.position = '';
  //               vehicleElements.spinner.classList.add('hide__default');
  //             }
  //           }

  //           console.log(data.confirm0DepositResponse);
  //           updateNavs();
  //           checkNavLoad();
  //           return data;
  //         });
  //     });
  //   }
  // };

  const getFinanceSessionObject = () => {
    const financeSessionObject = sessionStorage.getItem('_financeDataLayer');

    if (financeSessionObject) {
      const financeSessionObjectParsed = JSON.parse(financeSessionObject);
      window.dataLayer.push({
        financeSessionObjectParsed,
      });
    }
  };

  const initialize = () => {
    const vehicleElements = getVehicleElements();

    // Check whether vehicle has any ECOMM options
    let isStdVehContainer = true;
    const stdVehicleContainer = document.querySelector('.js-std-vehicle-container');
    if (savedQuote && savedQuote.Quote) {
      const vehicleFinanceSts = Object.values(savedQuote.Quote.VehicleFinanceSts);
      for (let i = 0; i < vehicleFinanceSts.length; i += 1) {
        if (vehicleFinanceSts[i]) {
          isStdVehContainer = false;
          break;
        }
      }
    }

    // If there are no ECOMM options
    if (isStdVehContainer && stdVehicleContainer) {
      stdVehicleContainer.classList.remove('hide__default');
    } else if (savedQuote && savedQuote.Quote) {
      // handleNoDepositElements();

      // Remove 0 from x.x0 on APR
      if (savedQuote.Quote.PCPAPR) {
        savedQuote.Quote.PCPAPR.APR = savedQuote.Quote.PCPAPR.APR.replace(/0$/, '');
      } else if (savedQuote.Quote.HPAPR) {
        savedQuote.Quote.HPAPR.APR = savedQuote.Quote.HPAPR.APR.replace(/0$/, '');
      }

      // Else if the quote exists
      if (document.querySelector('.js-vehicle-container')) {
        document.querySelector('.js-vehicle-container').classList.remove('hide__default');

        // If the quote has not expired
        if (savedQuote.QuoteExpired !== 'Expired' || isApplyForFinancePage) {
          vehicleElements.image.style.backgroundImage = `url('${
            savedQuote.Quote.VehicleDetail.vcj_image_results_src || savedQuote.Quote.VehicleImgUrl
          }')`;
          vehicleElements.body.innerHTML = generateVehicleDetailsBody(savedQuote);
          vehicleElements.mobileDesc.textContent = savedQuote.Quote.VehicleDsc;

          vehicleElements.detailsToggler.addEventListener('click', () => {
            // If the class was added the details having been hidden
            if (vehicleElements.body.classList.toggle('hide--tablet-down')) {
              vehicleElements.detailsToggler.textContent = 'View full details';
            } else {
              // Else the details are shown
              vehicleElements.detailsToggler.textContent = 'Hide full details';
            }
          });
        } else {
          // Else the quote expired
          handleExpiredQuote(vehicleElements);
        }

        // TODO: Should move this to the checkout file. Update the checkout title based on deal type
        const checkoutTitle = document.querySelector('.js-checkout-heading');
        if (checkoutTitle && savedQuote.receiptType !== 'RESERVE_IT_NOW') {
          checkoutTitle.textContent =
            savedQuote.custFinanceSts === 'CASH' ? '- Pay your balance' : '- Pay your deposit';

          // If deal has part ex
          if (savedQuote.Quote.PartEx.PartExSts === 'HasPartEx') {
            try {
              document.querySelector('.js-part-ex-deal').classList.remove('hide__default');
            } catch (err) {
              /* empty */
            }
          } else if (savedQuote.custFinanceSts !== 'CASH') {
            try {
              document.querySelector('.js-finance-deal').classList.remove('hide__default');
            } catch (err) {
              /* empty */
            }
          } else {
            try {
              const cashDealP = document.querySelector('.js-cash-deal');
              cashDealP.textContent = cashDealP.textContent.replace(
                '{vcj_typ}',
                savedQuote.Quote.VehicleDetail.vcj_typ === 'bike'
                  ? 'motorcycle'
                  : savedQuote.Quote.VehicleDetail.vcj_typ.toLowerCase(),
              );
              cashDealP.classList.remove('hide__default');
            } catch (err) {
              /* empty */
            }
          }
        }
      }

      if (vehicleElements.quoteDetailsContainer) {
        vehicleElements.quoteDetailsContainer.classList.remove('hide__default');
      }

      initlaizeFormNav(savedQuote);

      // Handle the reserve with no deposit functionality
      // handleNoDepositCheckout(savedQuote.Quote.QuoteId, savedQuote.Quote.dealHash);
    } else if (vehicleElements.quoteUnavailable) {
      // If the quote doesnt exist
      vehicleElements.quoteUnavailable.classList.remove('hide__default');

      if (vehicleElements.quoteDetailsContainer) {
        vehicleElements.quoteDetailsContainer.classList.add('hide__default');
      }
    }

    handleApplyForFinancePage(vehicleElements);

    // Check if the header is on the page and make it relative
    if (vehicleElements.header) {
      vehicleElements.header.style.position = 'relative';
    }

    // If the spinner is on the page hide it
    if (vehicleElements.spinner) {
      vehicleElements.spinner.classList.add('hide__default');
    }

    // Handle the page views for google analytics dataLayer
    handlePageView(window.location.pathname);

    // Check if passive option is supported to improve scrolling performance
    let passiveIfSupported = false;

    try {
      window.addEventListener(
        'test',
        null,
        Object.defineProperty({}, 'passive', {
          get() {
            passiveIfSupported = { passive: false };
          },
        }),
      );
    } catch (err) {
      /* empty */
    }

    // Handle the stickyPosition and add event listeners for scroll and resize
    handleStickyPosition(isStdVehContainer);
    window.addEventListener(
      'scroll',
      () => {
        handleStickyPosition(isStdVehContainer);
      },
      passiveIfSupported,
    );
    window.addEventListener(
      'resize',
      () => {
        handleStickyPosition(isStdVehContainer);
      },
      passiveIfSupported,
    );

    getFinanceSessionObject();
  };

  const checkoutConfirmationHandler = (event) => {
    if (event.origin !== `${window.location.protocol}//${window.location.hostname}`) {
      return;
    }
    if (event.data === 'CheckoutConfirmed') {
      try {
        // Ecommerce tracking
        window.dataLayer.push({
          event:
            savedQuote.receiptType === 'RESERVE_IT_NOW'
              ? 'reserveItNowComplete'
              : 'purchaseComplete',
          ecommerce: {
            purchase: {
              actionField: {
                id: orderDetail.orderId,
                affiliation:
                  savedQuote.receiptType === 'RESERVE_IT_NOW' ? 'Reserve it now' : 'BSM Buy Online',
                revenue:
                  savedQuote.receiptType === 'RESERVE_IT_NOW'
                    ? savedQuote.Quote.VehiclePrice
                    : savedQuote.Quote.CheckOutAmount,
                tax: '',
                shipping:
                  savedQuote.receiptType === 'RESERVE_IT_NOW'
                    ? ''
                    : savedQuote.Quote.DeliveryOptions.filter((el) => el.Chosen === 'Yes')[0].Cost,
              },
              products: [getProductDetails(savedQuote)],
            },
          },
        });

        ecommerceTracking(4, savedQuote.custFinanceSts);

        // Custom tracking
        window.dataLayer.push({
          event: `${savedQuote.custFinanceSts.toLowerCase()}Purchase`,
          checkoutPurchase: {
            saleValue: savedQuote.Quote.CheckOutAmount,
          },
        });
      } catch (err) {
        /* empty */
      }
      if (savedQuote.receiptType === 'RESERVE_IT_NOW') {
        try {
          let reservationFee = savedQuote.Quote.VehicleDetail.vcj_reservation_fee;

          if (reservationFee.includes('&pound;')) {
            reservationFee = reservationFee.replace('&pound;', '£');
          }

          dataLayer.push({
            event: 'reserveConfirmation',
            reserveValue: reservationFee,
          });
        } catch (err) {
          /* empty */
        }
      }

      updateNavs();
      checkNavLoad();

      // Set the height of the iframe
      const iframe = document.querySelector('#js-checkout-iframe');
      const iFrameDoc = iframe.contentDocument
        ? iframe.contentDocument
        : iframe.contentWindow.document;
      const height = Math.max(
        iframe.scrollHeight,
        iframe.offsetHeight,
        iFrameDoc.body.scrollHeight,
        iFrameDoc.body.offsetHeight,
      );
      iframe.style.minHeight = `${height + 10}px`;
    }
  };

  const handleEnquiryPage = (financeParams) => {
    // Get the interested radio button elements
    const interestedRadioElements = {
      PCPAPR: document.querySelector('input#Q635_0001'),
      HPAPR: document.querySelector('input#Q635_0002'),
      Cash: document.querySelector('input#Q635_0003'),
    };

    if (!savedQuote || !savedQuote.Quote || !financeParams) {
      return;
    }

    const hasFinanceOptions =
      savedQuote.Quote.VehicleFinanceSts.HPAPR ||
      savedQuote.Quote.VehicleFinanceSts.PCPAPR ||
      savedQuote.Quote.VehicleFinanceSts.Cash;
    const radioButtonContainer = document.querySelector('.js-show-if-monthly-price');

    // Loop through them to add which on the custoemr is intersted with
    for (const key in savedQuote.Quote.VehicleFinanceSts) {
      if (!savedQuote.Quote.VehicleFinanceSts[key] && interestedRadioElements[key]) {
        interestedRadioElements[key].parentElement.style.display = 'none';
      }

      if (interestedRadioElements[key]) {
        interestedRadioElements[key].checked = false;
      }
    }

    if (radioButtonContainer && hasFinanceOptions) {
      radioButtonContainer.classList.remove('hide__default');
    }

    // If finance is selected, select by default the selected finance
    if (
      financeParams.financeTypeSelected in interestedRadioElements &&
      interestedRadioElements[financeParams.financeTypeSelected]
    ) {
      interestedRadioElements[financeParams.financeTypeSelected].checked = true;
    } else if (financeParams.cashSelected && interestedRadioElements.Cash) {
      // If cash is selected
      interestedRadioElements.Cash.checked = true;
    } else {
      // If no finance or cash is selected
      for (const btnKey in interestedRadioElements) {
        if (interestedRadioElements[btnKey]) {
          interestedRadioElements[btnKey].checked = true;
        }
      }
    }
  };

  /**
   * Track monthly price session if the tracking object is set from ecomm app
   */
  const trackMonthlyPriceSession = () => {
    const sessionTrackingObject = sessionStorage.getItem('trackingObject');

    if (sessionTrackingObject !== null) {
      const trackingObject = JSON.parse(sessionTrackingObject);

      // Monthly Price Data Layer Object
      window.dataLayer.push({
        monthlyPrice: {
          deposit: trackingObject.monthlyPrice.deposit,
          term: trackingObject.monthlyPrice.term,
          mileage: trackingObject.monthlyPrice.mileage,
          hpFinance: trackingObject.monthlyPrice.hpFinance,
          pcpFinance: trackingObject.monthlyPrice.pcpFinance,
        },
      });
    }
  };

  // Create a customer session object
  // const customerSession = new CustomerSession();
  // Export customer session for global use
  // window.customerSession = customerSession;

  vm.onload(() => {
    initSessionChecks();
    if (typeof window.SessionCheck !== 'undefined') {
      window.SessionCheck.checkSession(AJAX_MBS_URL, 'check')
        .then((res) => {
          const data = res.myData;

          // Check if we are on an enquiry page
          const isEnquiryPage = /\/(request-a-callback|enquire)\//.test(window.location.pathname);
          isReserveItNowCheckout = /referrer=RESERVE_IT_NOW/i.test(window.location.search);

          const sessionQuote = sessionStorage.getItem('quote');

          // Check if the session storage has the quote object
          if (sessionQuote !== null && isEnquiryPage) {
            // Get the object
            const financeParams = JSON.parse(sessionQuote);

            trackMonthlyPriceSession();

            getFinance(financeParams)
              .then((quoteResponse) => {
                savedQuote = quoteResponse;

                handleEnquiryPage(financeParams);
                initialize();
              })
              .catch((err) => {
                vm.debug.error(err);
                initialize();
              });
          } else if (
            savedQuote === null &&
            data.myResultData[0].sessionSts === 'SECURE' &&
            orderDetail !== null
          ) {
            getQuote(orderDetail.QuoteId)
              .then((quoteResponse) => {
                savedQuote = quoteResponse;

                initialize();
              })
              .catch((err) => {
                vm.debug.error(err);
                initialize();
              });
          } else {
            initialize();
          }

          window.addEventListener('message', checkoutConfirmationHandler, false);

          // Add an event listener to the finance submitted event in order to add
          // checkmarks to the form nav items
          window.addEventListener('financeSubmitted', function financeSubmitHandler() {
            const financeStep = document.querySelector('.js-finance-step');
            const confirmationStep = document.querySelector('.js-confirmation-step');
            financeStep.querySelector('.nav-item__step-number').classList.add('hide__default');
            financeStep.querySelector('.nav-item__step-icon').classList.remove('hide__default');
            confirmationStep.classList.add('is-active');
            confirmationStep.querySelector('.nav-item__step-number').classList.add('hide__default');
            confirmationStep
              .querySelector('.nav-item__step-icon')
              .classList.remove('hide__default');
            window.removeEventListener('financeSubmitted', financeSubmitHandler);
          });
        })
        .catch((err) => {
          window.vm.debug.error(err);
        });
    } else {
      initialize();
    }
  });
})(window, document);
